<template>
  <v-dialog v-model="isOpen" :max-width="dialogWidth" persistent>
    <v-card>
      <v-card-title>
        {{ title }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="py-2">
        <div>
          <v-data-table 
            :headers="fileGeneratedHistoryHeaders" 
            :items="fileGeneratedHistory"
            :loading="fileGeneratedHistoryLoading" 
            :server-items-length="totalHits" 
            :items-per-page="itemsPerPage"
            :no-data-text="$vuetify.lang.t('$vuetify.common.no_data_available')"
            :options.sync="options"
            @update:options="getTasks"
            :footer-props="footerProps"
            disable-sort
            mobile-breakpoint="0"
            >
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id">
                    <td>{{ getRequestTime(item.name) }}</td>
                    <td>
                      {{ getDateRange(item.name) }}
                    </td>
                    <td>
                      <v-chip :color="item.status === 'success' ? 'green' : item.status === 'failed' ? 'red' : 'grey'"
                        dark>
                        {{ item.status }}
                      </v-chip>
                    </td>
                    <td>
                      {{ mapLocaleToLanguage(item.locale) }}
                    </td>
                    <td>
                        <span v-if="item.status === 'success' && getFileExpirationFromTaskName(item.name)"
                              @click="generatePresignedUrl(getDownloadUrl(item.message))"
                              style="cursor: pointer; color: blue; text-decoration: underline;">
                            Download
                        </span>
                      <span v-else>N/A</span>
                    </td>
                    <td>
                      {{ item.status === "success" && getFileExpirationFromTaskName(item.name) ? getFileExpirationFromTaskName(item.name) : item.status === "pending" ? "N/A" :  "Expired" }}
                    </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="justify-end">
        <v-btn outlined color="error" @click="closeModal">{{
          $vuetify.lang.t("$vuetify.common.close_btn")
          }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { GET_TASKS_BY_PREFIX, GENERATE_PRESIGNED_URL, ADD_ALERT } from "@/store/_actiontypes";
import { getDateRange, getDownloadUrl, getFileExpirationFromTaskName, getRequestTime, mapLocaleToLanguage } from "../../helpers/fileGeneration";
export default {
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    closeModal: {
      type: Function,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    history_type: {
      type: String,
      required: false,
    },
    prefix: {
      type: String,
      required: true,
    }
  },

  data() {
    return {
      isOpen: false,
      fileGeneratedHistoryLoading: false,
      fileGeneratedHistory: [],
      totalHits: 0,
      itemsPerPage: 5,
      currentPage: 1,
      options: { page: 1, itemsPerPage: 5 },
      footerProps: {'items-per-page-options': [5, 15, 25]},
      fileGeneratedHistoryHeaders: [
        {
          text: this.$vuetify.lang.t(
            "$vuetify.logs_file_generation.request_date"
          ),
          value: "date",
          align: 'start',
          sortable: 'false'

        },
        {
          text: this.$vuetify.lang.t(
            "$vuetify.logs_file_generation.date_range"
          ),
          value: "date_range",
          sortable: "false"
        },
        {
          text: this.$vuetify.lang.t("$vuetify.table_header.status"),
          value: "status",
          sortable: "false"
        },
        {
          text: this.$vuetify.lang.t("$vuetify.logs_file_generation.language"),
          value: "locale",
          sortable: "false"
        },
        {
          text: this.$vuetify.lang.t("$vuetify.logs_file_generation.file_url"),
          value: "file_url",
          sortable: "false"
        },
        {
          text: this.$vuetify.lang.t(
            "$vuetify.logs_file_generation.expiration"
          ),
          value: "expiration",
          sortable: "false"
        },
      ],
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.account.user,
      selectedProject: (state) => state.project.selectedProject,
      dateRangeText: function () {
        return this.fileDateRange.join(" ~ ");
      },
    }),
    dialogWidth() {
      return window.innerWidth <= 768 ? '95%' : '57%';
    }
  },

  watch: {
    open: {
    immediate: true,
    handler(newVal) {
      this.isOpen = newVal;
    }
    },
    
  },

  methods: {
    ...mapActions("task", [GET_TASKS_BY_PREFIX]),
    ...mapActions("dataset", [GENERATE_PRESIGNED_URL]),
    getFileExpirationFromTaskName,
    getDownloadUrl,
    getRequestTime,
    getDateRange,
    mapLocaleToLanguage,
    getTasks({ page, itemsPerPage }){
      this.currentPage = page;
      this.itemsPerPage = itemsPerPage;
      
      const start = (page - 1) * itemsPerPage;
      const size = itemsPerPage;
      this.getFileGeneratedHistory(start, size)
    },
    getFileGeneratedHistory(start, size) {
      this.fileGeneratedHistoryLoading = true;
      const task_prefix =  `${this.prefix}_${this.selectedProject.id}`
      this.GET_TASKS_BY_PREFIX({
        project_id: this.selectedProject.id,
        task_prefix,
        task_status: "all_status",
        start: start,
        size: size,
      })
        .then(
          (response) => {
            this.fileGeneratedHistory = response.data?.detail?.response;
            this.totalHits = response.data?.detail?.total_tasks;
          },
          (error) => {
            console.error(error);
          }
        )
        .finally(() => {
          this.fileGeneratedHistoryLoading = false;
        });
    },

    generatePresignedUrl(url){
      const match = url.match(/\/contents\/(.*?)\.csv/);
      if(match){
        const s3_key = `contents/${match[1]}.csv`
        this.GENERATE_PRESIGNED_URL({project_id: this.selectedProject.id,s3_key}).then(res => {
          const a = document.createElement("a");
          a.href = res.data.detail.download_url;
          a.download = "";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }).catch(e=> {
          console.error("error", e)
        })
      } else  {
        this.$store.dispatch(
                `alert/${ADD_ALERT}`,
                {
                  message: this.$vuetify.lang.t(
                    "$vuetify.logs_file_generation.download_url_missing",
                  ),
                  color: "error",
                },
                { root: true },
        );
      }
    },
  },
};
</script>
